var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoHdiFigma(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 32,
    viewBox: "0 0 92 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8438 10.6667H10.8971V21.3334H22.8438V10.6667Z",
    fill: "#DD2D27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.230438 0H11.132V32H0.230438V0ZM22.5647 0H33.4663V32H22.5647V0ZM80.6356 0H91.5371V32H80.6385L80.6356 0ZM42.6001 0.287572H57.3853C66.1102 0.287572 73.251 7.43307 73.251 16.1128C73.251 24.7983 66.1102 31.9423 57.3853 31.9423H42.6001V0.287572ZM52.6069 7.94617H53.866C58.831 7.94617 62.8916 11.7204 62.8916 16.3295C62.8916 20.9416 58.831 24.7129 53.866 24.7129H52.6069V7.94617Z",
    fill: "#00A657"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHdiFigma);
export default __webpack_public_path__ + "static/media/logoHdiFigma.90db35400a2254d405ab9d3cc8552ec9.svg";
export { ForwardRef as ReactComponent };